import type { SiretSearchRepository, SiretSuggestion } from "@shared-kernel/application/ports/siret-search/siret-search-repository";

interface GouvSearchResult {
  nom_complet?: string;
  nom_raison_sociale?: string;
  siege?: {
    siret?: string;
    adresse?: string;
    code_postal?: string;
    libelle_commune?: string;
  };
}

interface GouvSearchResponse {
  results?: GouvSearchResult[];
}

const API_URL = "https://recherche-entreprises.api.gouv.fr/search";

export class GouvSiretSearchRepository implements SiretSearchRepository {
  async searchSiret(query: string, signal?: AbortSignal): Promise<SiretSuggestion[]> {
    const url = `${API_URL}?q=${encodeURIComponent(query)}&per_page=10`;
    const response = await fetch(url, { signal });
    if (!response.ok) return [];
    const json = (await response.json()) as GouvSearchResponse;
    const results = json.results ?? [];
    return results.map(toSuggestion).filter((s): s is SiretSuggestion => s !== null);
  }
}

function toSuggestion(result: GouvSearchResult): SiretSuggestion | null {
  const siret = result.siege?.siret;
  if (!siret) return null;
  const name = result.nom_complet ?? result.nom_raison_sociale ?? "";
  const address = formatAddress(result.siege);
  return { siret, name, address };
}

function formatAddress(siege: GouvSearchResult["siege"]): string {
  if (!siege) return "";
  if (siege.adresse) return siege.adresse;
  return [siege.code_postal, siege.libelle_commune].filter(Boolean).join(" ");
}
